import Styled from "styled-components";

export const Container = Styled.div`
padding: 15px;
padding-top: 40px;
width: 82%;
margin: 0 auto;
min-height: 100%;
flex-direction:column;
gap: 10px;
display: flex;
font-size: ${props => props.theme.fontSize.medium};
overflow-y: auto;
overflow-x: hidden;
justify-content:center;
align-content: center;
`;

export const MenuContent = Styled.div`
width: 100%;
max-height: 20px;
min-height: 9vh;
display: flex;
justify-content: space-between;
color: ${props => props.theme.test.color2};
font-size: ${props => props.theme.fontSize.large} !important;

`;
export const FormContent = Styled.div`
display: flex;
// width: 80%;
border: 0.1px solid rgba(0,0,0,.2);
gap: 10px;
padding: 20px;
background: ${props => props.theme.colors.background};
//height: auto !important;
//border: 0.0001px solid;
border-radius: 15px;

flex-direction: column;
//background: pink;
@media only screen and (max-width: 991px) {
  flex-direction: row !important;
    flex-wrap: wrap !important;
}
`;

export const ContainerInput = Styled.div`
gap: 10px;
//background: red;
display: flex;
  flex-wrap: wrap;
`;
export const BoxInput = Styled.div`
//background: green;
flex-basis: 80%;
gap: 10px;
display: flex;
flex-direction: column;
@media only screen and (max-width: 991px)  {
 
   min-width: 100% !important;
}

//border: 0.5px solid;
`;
export const Box = Styled.div`
flex-basis: 100%;
flex-shrink: 1;
flex-grow: 0;
border-radius: 5px;
border-radius: 2px;
flex-direction:column;
gap: 10px;
display: flex;
@media only screen and (max-width: 991px) {
  flex-basis: 100%;
  margin: 0;
}

`;

export const ContentBoxColumn = Styled.div`
flex-grow: 0;
border-radius: 5px;
border-radius: 2px;
flex-direction:row;
 align-items: center;
 justify-content: center;
gap: 10px;
display: flex;
@media only screen and (max-width: 991px) {
  flex-basis: 100%;
  margin: 0;
}

`;

export const Box75 = Styled.div`
flex-basis: 66%;
gap: 10px;
flex-grow: 0;
border-radius: 5px;

border-radius: 2px;

@media only screen and (max-width: 991px) {
  flex-basis: 100%;
margin: 0;

}

`;

export const Box50 = Styled.div`
flex-basis: 45%;
flex-grow: 0;
border-radius: 5px;

border-radius: 2px;
gap: 10px;
@media only screen and (max-width: 991px) {
  flex-basis: 100%;
  margin: 0;
  gap: 10px;

}

`;

export const Box40 = Styled.div`
flex-basis: 40%;
flex-shrink: 1;
flex-grow: 0;
border-radius: 5px;

border-radius: 2px;
gap: 10px;
@media only screen and (max-width: 991px) {
  flex-basis: 100%;
margin: 0;

}

`;

export const Box30 = Styled.div`
flex-basis: 32%;
flex-shrink: 1;
flex-grow: 0;
border-radius: 5px;

border-radius: 2px;
gap: 10px;
justify-content:center;
align-items: center;
@media only screen and (max-width: 991px) {
  flex-basis: 100%;;
 margin: 0;
}
//margin-right: 20px;
`;
export const Box25 = Styled.div`
flex-basis: 28%;
flex-grow: 0;
border-radius: 5px;

border-radius: 2px;
gap: 10px;

@media only screen and (max-width: 991px) {
  flex-basis: 100%;
  margin: 0;
}
//margin-right: 20px;
`;

export const Box15 = Styled.div`
flex-basis: 10%;
margin-bottom: 15px;
flex-shrink: 1;
flex-grow: 0;
border-radius: 5px;
//background: black;
border-radius: 2px;

@media only screen and (max-width: 991px) {
  flex-basis: 100%;
  margin: 0;
 
}
//margin-right: 20px;
`;
export const Box10 = Styled.div`
width: 15%;
gap: 10px;
border-radius: 5px;
//background: white;
border-radius: 2px;

@media only screen and (max-width: 991px) {
  flex-basis: 100%;
 margin: 0;
}
`;
export const Box8 = Styled.div`
width: 10%;
border-radius: 5px;
//background: white;
border-radius: 2px;
gap: 10px;

@media only screen and (max-width: 991px) {
  flex-basis: 100%;
 margin: 0;
}
`;

export const Box2Items = Styled.div`
gap: 10px;
display: flex;
flex-basis: 100%;
flex-direction: column;

justify-content:space-between;



//border: 0.5px solid;

@media only screen and (max-width: 991px) {
  flex-direction: row !important;
    flex-wrap: wrap !important;
    flex-basis: 100%;
}
`;

export const BoxColumnRow = Styled.div`
gap: 10px;
display: flex;
align-items: center;
flex-direction: row;



//border: 0.5px solid;

@media only screen and (max-width: 991px) {
  flex-direction: row !important;
    flex-wrap: wrap !important;
    flex-basis: 100%;
}
`;

export const Box3Items = Styled.div`


flex-basis: 80%;
display: flex;
flex-direction: row;
gap: 10px;

@media only screen and (max-width: 991px) {
  flex-direction: row !important;
    flex-wrap: wrap !important;
    flex-basis: 100%;
}
//border: 0.5px solid;


//background: orange;
`;

export const BoxButtom = Styled.div`

flex-basis: 100%;
display: flex;
justify-content: space-between;
flex-direction: row;
gap: 10px;

`;
export const Select = Styled.select`
 display: flex;
  width: 100%;
  font-size: 18px;
  background: transparent;

  color: black;
  height: 40px;
  border-radius: 5px;
  border: 0.1px solid rgba(0,0,0,.2);

`;
export const Option = Styled.option` 
  width: 100%;
  color: black;
  `;
export const LabelSelect = Styled.div`
  font-weight: bold;
  font-size: ${props => props.theme.fontSize.small};

  `;
export const BoxColunm = Styled.div`
  display:flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  `;
export const Label = Styled.div`
  font-weight: 600;
  
  font-size: ${props => props.theme.fontSize.small};

  
  `;
export const TextLabel = Styled.div`
  font-size: ${props => props.theme.fontSize.medium};
  color:${props => props.theme.test.color3};
  `;
export const SubTitle = Styled.h5`
  color:${props => props.theme.test.color3};
  font-size: 27px;
  `;

export const ContainerTable = Styled.div`
min-height: 60vh;
display: flex;
flex-direction: column;
justify-content: center;
border: 0.5px solid rgba(0,0,0,.5);
`;
export const Text = Styled.label`
font-size: 95%;
`; export const TextSpan = Styled.label`
text-transform: capitalize;
font-size: 70%;
`;
export const Header = Styled.div`
background: ${props => props.theme.colors.primary};
display: flex;
padding-left: 20px;
align-items: center;
height: 50px;

`; export const SubContentHeader = Styled.div`
background: ${props => props.theme.colors.alternative};
display: flex;
align-items: center;
width: 100%;
height: 40px;


`;
export const TitleFieldForm = Styled.p`
    font-weight: bold;
    color :#101727;
    font-size:  ${props => props.theme.fontSize.small};
    text-transform: uppercase
`;

export const ContentLeft = Styled.div`
width: 70%;
display:flex;
height: 40px;
color: #ffffff;
align-items: center;
margin-left: 2vw;


`;
export const ContentRight = Styled.div`
width: 25%;

display:flex;
align-items: center;
justify-content: space-around;
height: 40px;


`;
export const BoxCard = Styled.div`
width: 100%;
display:flex;
flex-direction: row;
justify-content: space-evenly;

`;
export const Message = Styled.label`
color: red;
font-size: 14px;
margin: 0px !important;
`;
export const Madatory = Styled.label`
margin-bottom: -5px;
color: red;
font-size: 18px;
`;
export const Pagination = Styled.label`
font-size: 16px;
font-weight: bold;
`;
export const BlocoNome = Styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;